import React, { useState, useRef, useEffect } from 'react';
import usePositionsStore from '../../stores/PositionsStore';
import axios from 'axios';
import Cookies from 'js-cookie'
import  useUserStore  from '../../stores/UserStore'
import  useUserSettingStore from '../../stores/UserSettingsStore';
import useSettingsStore from '../../stores/SettingsStore';
import { AiOutlineClose } from "react-icons/ai";
import { RiDeleteBack2Fill } from "react-icons/ri";
import { IoMdCloseCircle } from "react-icons/io";

function Positions() {
  const positions = usePositionsStore((state) => state.positions);
  const positionsCount = usePositionsStore((state) => state.positionsCount);
  const fetchPositions = usePositionsStore((state) => state.fetchPositions);
  const clearSelectedSettingStore = useSettingsStore((state) => state.clearSelectedSetting)
  const settings = useSettingsStore((state) => state.settings)
  const selectSetting = useSettingsStore((state) => state.selectSetting)
  const selectedSetting = useSettingsStore((state) => state.selectedSetting)
  const fetchUserSettings = useUserSettingStore((state) => state.fecthUserSettings)


  const positionsRef = useRef(null); 
  const contextMenuRef = useRef(null); 

  const [selectedAccordion, setSelectedAccordion] = useState("Stop Settings")
  const [filledInput, setFilledInput] = useState({})
  const [filledStopInput, setFilledStopInput] = useState({})
  const [stopSettings, setStopSettings] = useState({})
  const [contextMenu, setContextMenu] = useState(null);
  const [hoveredCoin, setHoveredCoin] = useState(null)
  const [modalData, setModalData] = useState(null);
  const stop_settings_list = useSettingsStore((state) => state.stopSettingList)
  const [percentage, setPercentage] = useState(100);
  // const [trigger, setTrigger] = useState({triggerInstrument: '', triggerPrice: null});
  // const [timeStop, setTimeStop] = useState()
  // const [stopPrice, setStopPrice] = useState()
  // const [stopTime, setStopTime] = useState()
  // const [stopInstrument, setStopInstrument] = useState()
  // const [exitPrice, setExitPrice] = useState()
  // const [exitTime, setExitTime] = useState()
  // const [exitInstrument, setExitInstrument] = useState()


  const [createTradeQuantity, setCreateTradeQuantity] = useState(0)

  const [actionList, setActionList] = useState({})
  
  const stop_input_list = ["stop_price", , "exit_price", 'trigger_instrument']

  // useEffect 1
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (contextMenuRef.current && !contextMenuRef.current.contains(event.target)) {
        handleCloseContextMenu();
      }
    };
    if (contextMenu) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [contextMenu]); 


  // useEffect 2
  useEffect(() => {
    const fetchData = async () => {
      try {
        await fetchUserSettings();
      } catch (error) {
        console.log("Error fetching user settings", error);
      }
    };
    if (!selectedSetting || selectedSetting === "undefined") {
      selectSetting("DEFAULT");
      return;
    }
    
    fetchData();
    console.log('Selexted')
    if (selectedSetting && Object.keys(selectedSetting).length !== 0) {

      setStopSettings((prevStopSettings) => ({
        ...prevStopSettings,
        ...selectedSetting.stop_settings,
      }));
    } else {
      selectSetting("DEFAULT")
      // setStopSettings({});
    }
  }, [selectedSetting, fetchUserSettings]);

  
//STOP SETTINGS
const details = {
  'trade': {
    "targets": "Example: BTCUSDT:10000 \n ETHUSDT:-1000",
    "max_order_size": 'Order size will be capped at this value sometimes it can round slightly over if close to min_nominal',                      
    "trigger_price": 'Example: \n  >24000 <19000 \n >23000/>24000/>25000 \n default < if not specified', 
    "stop_price": 'closed if price < or > stop_price (depend on long/short) (can be added/changed later)', 
    "exit_price": 'closed if price < or > exit_price (depend on long/short) (can be added/changed later)', 
    "price_limit": 'Example: 24000 \n 22000/23000/24000 \n will never trade > or < to price_limit \n (do not specify < or >)', 
    "break_time_in": 'Example: 10 \n 10/20/30/40 \n if we spend X minutes over trigger_price', 
    "break_time_out": 'Example : 5 \n if X % under trigger_price will reset break_time_in', 
    "depth_min": 'Example: 0.001 \n how deep we post our order in the book (in %)',     
    "depth_max": 'Example: 0.002 \n random between depth_min/depth_max (must be >= depth_min)',     
    "price_limit_is_last_ex_price": 'Example : 0 or 1 \n our last exPrice become our price_limit \n',  
    "cancel_price_gap": 'Example: 0.0001 \n do not touch',      
    "rdm_qty_range": 'If max_order_size is 1000 and rdm_qty_range is 20 we will post an order size between 800 and 1000 ',     
    "aggro_order_on": 'Example : 0 or 1 \n will allow to be taker',     
    "aggro_depth": 'How deep we will try to get filled with aggro in %',     
    "aggro_order_delay": 'In seconds \n Max delay between aggro orders',     
    "aggro_book_ratio": 'Example : 5\n Ratio between bid/ask at 0.1% spread if bid vs ask ratio is > X  \n allow aggro order ',     
    "aggro_forced_if_no_fill_in": 'Will force an aggro order if you didnt get filled in X seconds',        
    "fill_delay": 'Will wait X seconds to send another order when filled', 
    "maker_only": "The order will be maker, unless it's an aggro order",
  },
  "algo": {
    "targets": "Example: BTCUSDT:10000 \n ETHUSDT:-1000",
    "max_order_size": 'Order size will be capped at this value sometimes it can round slightly over if close to min_nominal',                      
    "trigger_price": 'Example: \n  >24000 <19000 \n >23000/>24000/>25000 \n default < if not specified', 
    "trigger_instrument": 'If trigger_price is specified \n it will use the first instrument in target as default \n else you can use this instead', 
    "stop_price": 'closed if price < or > stop_price (depend on long/short) (can be added/changed later)', 
    "exit_price": 'closed if price < or > exit_price (depend on long/short) (can be added/changed later)', 
    "price_limit": 'Example: 24000 \n 22000/23000/24000 \n will never trade > or < to price_limit \n (do not specify < or >)', 
    "break_time_in": 'Example: 10 \n 10/20/30/40 \n if we spend X minutes over trigger_price', 
    "break_time_out": 'Example : 5 \n if X % under trigger_price will reset break_time_in', 
    "stop_max_order_size": 'Order size of your stops/exits',      
    "depth_min": 'Example: 0.001 \n how deep we post our order in the book (in %)',     
    "depth_max": 'Example: 0.002 \n random between depth_min/depth_max (must be >= depth_min)',     
    "price_limit_is_last_ex_price": 'Example : 0 or 1 \n our last exPrice become our price_limit \n',    
    "cancel_price_gap": 'Example: 0.0001 \n do not touch',   
    "rdm_qty_range": 'If max_order_size is 1000 and rdm_qty_range is 20 we will post an order size between 800 and 1000 ',     
    "aggro_order_on": 'Example : 0 or 1 \n will allow to be taker',     
    "aggro_depth": 'How deep we will try to get filled with aggro in %',     
    "aggro_order_delay": 'In seconds \n Max delay between aggro orders',     
    "aggro_book_ratio": 'Example : 5\n Ratio between bid/ask at 0.1% spread if bid vs ask ratio is > X  \n allow aggro order ',     
    "aggro_forced_if_no_fill_in": 'Will force an aggro order if you didnt get filled in X seconds',     
    "fill_delay": 'Will wait X seconds to send another order when filled',     
    "algo_type": 'Leave blank or algo_nom \n WARNING: algo_nom target amount is in coin size \n Example: BTCUSDT:1 => you will have 1 BTC',
    "maker_only": "The order will be maker, unless it's an aggro order",
  }
}

  const data_accordion = {"Stop Settings": stop_settings_list}
  const accordion2 = {"Stop Settings": stop_settings_list}
  const toggleAccordion = (option) => {
    if (selectedAccordion === option) {
        return setSelectedAccordion(null)
    }
    setSelectedAccordion(option)
}
const handleStopChange = (event) => {
  const name = event.target.name 
  const value = event.target.value 
  setStopSettings((prevStopSettings) => ({
      ...prevStopSettings,
      [name]: value,
  }))
}
const clearSelectedSetting = () => {

    setStopSettings({})
    clearSelectedSettingStore()
}

  // CONTEXT MENU
  const handleContextMenu = (event, exchange, coin, coinName, size, avgPrice) => {
    event.preventDefault(); 
    setHoveredCoin(exchange+"_"+coin)
    if (positionsRef.current) { 
      const widgetRect = positionsRef.current.getBoundingClientRect();
      setContextMenu({
        x: event.clientX - widgetRect.left,
        y: event.clientY - widgetRect.top,
        exchange: exchange,
        coin: coin,
        coinName: coinName,
        size: size,
        avgPrice: avgPrice
      });
    }
  };
  const handleCloseContextMenu = () => {
    console.log('Closin')
    
    setContextMenu(null); 
    setHoveredCoin(null)
  };
  const handleOptionClick = (option) => {
    setModalData({
      exchange: contextMenu.exchange,
      coin: contextMenu.coin,
      coinName: contextMenu.coinName,
      size: contextMenu.size,
      avgPrice: contextMenu.avgPrice,
      option: option, 
    });
    handleCloseContextMenu(); 
  };

  //MODAL
  const closeModal = () => {
    setPercentage(100)

    setCreateTradeQuantity(0)

    setModalData(null);
    setFilledStopInput({})
  };

  // FORM
  const handleSliderChange = (event) => {
    const percent = event.target.value
    setPercentage(percent);
    if (percent == 100) {
      setCreateTradeQuantity(modalData.size)
    }else if ( percent == 0) {

      setCreateTradeQuantity(0)
    
  } else{
    const quantity = (percentage * modalData.size / 100)
    const correctValue = Number((quantity).toFixed(5))
    setCreateTradeQuantity(correctValue)
  }
  };
  const handleQuantityChange = (e) => {
    const quantity = e.target.value
    setCreateTradeQuantity(e.target.value)
    const percent = Number(((quantity / modalData.size) * 100).toFixed(1));
    setPercentage(percent)

  }
  const handlePercentChange = (percent) => {
    setPercentage(percent)
    const quantity = (percent * modalData.size / 100)
    const correctValue = Number((quantity).toFixed(5))
    setCreateTradeQuantity(correctValue)

  }
  const handleStopInputChange = (e) => {
    const {name, value} = e.target
    setFilledStopInput((prevFilledInput) => ({
      ...prevFilledInput,
      [name]: value,
      })
    )
  }

 


  
  const handleSubmit = async (event) => {
    event.preventDefault();

    
    const payload = {
      "exchange": modalData.exchange,
      "pair": modalData.coin,
      "quantity": createTradeQuantity,
      "settings": stopSettings,
      "avgPrice": modalData.avgPrice
    }
    if (createTradeQuantity === 0) {
      if (percentage === 100) {
        payload["quantity"] = modalData.size
      }
    }
    
    Object.keys(filledStopInput).map(function(input) {
      return(
        payload[input] = filledStopInput[input]
      )
  }) 
    console.log('Payload', payload)
    const token = Cookies.get('token')
    try {
      const response = await axios({
          headers: { Authorization: token },
          method: "POST",
          url : "/api/stop_position",
          data : payload
      })
      if (response.status === 200) {
         
          console.log('Sent stop position')
      }
  } catch (err) {
    console.log('ERROR', err)     
  }
  
    closeModal();
  };

  function formatNumber(value, maxDecimals) {
    const num = Number(value);
    if (isNaN(num)) return value;
  
    const rounded = Number(num.toFixed(maxDecimals));
    return rounded.toString();
  }
  
  

  return (
    <div className="widget_body" ref={positionsRef}>
      <div className="positions_container">

        {Object.keys(positions).map((exchange) => (
          <div key={exchange}>
            <h3>{exchange.split('@')[1].toUpperCase()}</h3> 
            <div className="position_container">
                  <div className="temoin"></div>
                  <div className="cell cell_instrument position_instrument">Contracts</div>
                  <div className="cell position_qty">Qty</div>
                  <div className="cell position_value">Value</div>
                  <div className="cell position_value">Avg Price</div>
                  <div className="cell position_pnl">Upnl</div>
                </div>
            {Object.keys(positions[exchange]).map((coin) => {
              const position = positions[exchange][coin];
              const side = position.side;
              
              const coinName = coin.replace(/\d+$/, '');
              const coinNumber = coin.replace(coinName, '');
              const avgPrice = position.avgPrice
              let prefix = null;
              if (coinNumber === '0') {
                prefix = <span className="position_type">OW</span>;
              } else if (coinNumber === '1' || coinNumber === '2') {
                prefix = <span className="position_type">HM</span>;
              }
              const size = side === "Sell" ? -Math.abs(position.size) : position.size;
              return (
                <div
                  className={`position_container line_hover no_drag${hoveredCoin === exchange+"_"+coin ? ' hovered' : ''}`}
                  key={exchange+"_"+coin}
                  onContextMenu={(event) => handleContextMenu(event, exchange, coin, coinName, size, avgPrice)}
                  onMouseEnter={() => setHoveredCoin(exchange+"_"+coin)}
                  onMouseLeave={() => !contextMenu && setHoveredCoin(null)}
                >
                  <div className={side === "Sell" ? "temoin sell" : "temoin buy"}></div>
                  <div className="cell cell_instrument position_instrument" id={coin}>{prefix}{coinName}</div>
                  <div className={side === "Sell" ? "cell position_qty sell_text" : "cell position_qty buy_text"}>{size}</div>
                  {/* <div className="cell position_value">{position.positionValue}</div>
                  <div className="cell position_value">{position.avgPrice}</div>
                  <div className="cell position_pnl">{position.unrealisedPnl}</div> */}
                  <div className="cell position_value">
                    {formatNumber(position.positionValue, 2)}
                  </div>
                  <div className="cell position_value">
                    {formatNumber(position.avgPrice, 6)}
                  </div>
                  <div className="cell position_pnl">
                    {formatNumber(position.unrealisedPnl, 2)}
                  </div>


                </div>
              );
            })}
          </div>
        ))}
      </div>

      {contextMenu && (
        <ul className="context_menu no_drag" style={{ top: `${contextMenu.y}px`, left: `${contextMenu.x}px`, position: 'absolute' }} ref={contextMenuRef}>
          <li className="li" onClick={() => handleOptionClick('create_trade')}>Create Position Trade</li>
        </ul>
      )}
       {modalData && (
        <div className="modal_overlay no_drag">
          <div className="modal">
            <h3 className='modal_option_title'>{modalData.option.replaceAll('_', ' ')}</h3>
            <h4 className='modal_coin_name'><span className='exchange_name_title'>{modalData.exchange.split('@')[1].toUpperCase()}</span> {modalData.coinName}: <span className="position_quantity">{modalData.size}</span></h4>
            <form className='modal_form_container' onSubmit={handleSubmit}>
                <div className="create_trade_input_container">
                  <h3 className='modal_input_title'>Quantity  </h3>
                   <input className="input modal_input"  value={percentage === 100 ? modalData.size : createTradeQuantity} onChange={(e) => handleQuantityChange(e)}/>
                </div>
                <div className="create_trade_input_container">
                  <input type="range" id="percentage-slider" name="percentage" min="1" max="100" value={percentage} onChange={handleSliderChange} className="slider"/>
                  <span className="percentage_display">{percentage}%</span>
                  
                </div>
                <div className="create_trade_input_container">
                <ul className="percent_button_container">
                    <li className="percent_button li"  onClick={()=> handlePercentChange(25)}>25%</li>
                    <li className="percent_button li"  onClick={()=> handlePercentChange(50)}>50%</li>
                    <li className="percent_button li" onClick={()=> handlePercentChange(75)}>75%</li>
                    <li className="percent_button li" onClick={()=> handlePercentChange(100)}>100%</li>
                  </ul>
                </div>
                {stop_input_list.map((input, i) => 
                  <div className="create_trade_input_container">
                    <h3 className="modal_input_title">{input.replaceAll("_", " ")}</h3>
                    <input  className="input modal_input" value={filledStopInput[input] || ""} name={input} onChange={(e)=> handleStopInputChange(e)} />
                  </div>
                )}
                <div className="settings_list_container">
                  <h3 className='modal_input_title'>Stop Settings</h3>
                  <ul className=" form_radio_container">
                  {settings && Object.keys(settings).length > 0 && Object.keys(settings).map(function(setting) {
        
                          return(
                          <li className={selectedSetting && selectedSetting["setting_name"] === setting ? "li li_setting active_li_setting no_drag" : "li li_setting no_drag"}  key={setting}>
                   
                              <p key={setting+"input"} className="no_drag setting_name" onClick={() => selectSetting(setting)}>{setting.replaceAll('_', ' ')}</p>
                             {selectedSetting && selectedSetting["setting_name"] === setting ? <IoMdCloseCircle className="no_drag close_selected_setting" onClick={() => clearSelectedSetting(setting)}/> : null}
                        </li>)
                      })
                  }  
                  </ul>
              </div>
                <div className="accordion accordion_positions" id="trade_stop_settings">
                  {Object.keys(accordion2).map(function(option, i) {
                      return(
                          <div className='item' key={"item" +i}>
                              <div className="title no_drag" key={"title" + i} onClick={() => toggleAccordion(option)}>
                                  <h3 key={"h3_" +i}>{option}</h3>
                                  <span key={"span_" +i}>{selectedAccordion === option ? "-" : "+"}</span>

                            </div>
                            {data_accordion[option].map((item, j) => 
                            
                            <div key={"content2_trade" +j} className={selectedAccordion === option ? "content show" : "content"}>
                                <p className="accordion_p" key={"p" +j}>{item.replaceAll('_', ' ')}</p>
                                <input key={"input_" +j} className="input no_drag" name={item} id={option} value={stopSettings[item] || ''} onChange={(e) => handleStopChange(e)} type="text" />
                                {/* <div key={"icon" +j} className="info_icon" id={item +"_stop_"} onMouseOver={(e) => showDetails(e)} onMouseLeave={(e) => hideDetails(e)}>ⓘ</div> */}
                                <p key={"detail" +j} name={item} id={item + "_stop_details"} className="input_details hide_details">{details[item]}</p>
                                
                            </div>
                            )}
                          </div>
                        )
                    })}
                </div>

             
              <button className="btn modal_submit" type="submit">Create</button>
              
            </form>

            <AiOutlineClose className="close_modal" onClick={()=> closeModal()}/>
          </div>
        </div>
      )}
    </div>
  );
}

export default Positions;

